import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { FollowupState } from '../../types'

export const deleteFollowupAction = createAsyncAction(
  '@followup/DELETE_FOLLOWUP_REQUEST',
  '@followup/DELETE_FOLLOWUP_SUCCESS',
  '@followup/DELETE_FOLLOWUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: FollowupState): FollowupState => ({
  ...state,
  isLoadingDeleteFollowup: true
})

const success = (state: FollowupState, action: ActionType<typeof deleteFollowupAction.success>): FollowupState => ({
  ...state,
  isLoadingDeleteFollowup: false,
  isSuccessOnDeleteFollowup: true
})

const failure = (state: FollowupState, action: ActionType<typeof deleteFollowupAction.failure>): FollowupState => ({
  ...state,
  isLoadingDeleteFollowup: false,
  isErrorOnDeleteFollowup: true
})

export const deleteFollowupHandle = { asyncAction: deleteFollowupAction, request, success, failure }
